import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import './segmentsMenuContent.scss';
var SegmentsMenuItem = function SegmentsMenuItem(_ref) {
  var title = _ref.title,
    url = _ref.url;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: url
  }, title));
};
var SegmentsMenuSection = function SegmentsMenuSection(_ref2) {
  var section = _ref2.section;
  return /*#__PURE__*/React.createElement("div", {
    className: "segments-menu-section"
  }, /*#__PURE__*/React.createElement("h4", null, section.url ? /*#__PURE__*/React.createElement("a", {
    href: section.url
  }, section.title) : section.title), section.items.length > 0 && /*#__PURE__*/React.createElement("ul", null, section.items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SegmentsMenuItem, {
      key: index,
      title: item.title,
      url: item.url
    });
  })));
};
var SegmentsMenuColumn = function SegmentsMenuColumn(_ref3) {
  var segment = _ref3.segment;
  return /*#__PURE__*/React.createElement("div", {
    className: "segments-menu-column"
  }, segment.title ? /*#__PURE__*/React.createElement("h3", null, segment.title) : /*#__PURE__*/React.createElement("h3", {
    "aria-label": "Continued list"
  }, "\xA0"), /*#__PURE__*/React.createElement("div", {
    className: "segments-menu-sections"
  }, segment.items.map(function (section, index) {
    return /*#__PURE__*/React.createElement(SegmentsMenuSection, {
      key: index,
      section: section
    });
  })));
};

// Allow segments with a lot of items to be split into two columns
var chunkSegments = function chunkSegments(segments, chunkSize) {
  return segments.flatMap(function (segment) {
    if (segment.items.length <= chunkSize) {
      return [segment];
    }
    return [_objectSpread(_objectSpread({}, segment), {}, {
      items: segment.items.slice(0, chunkSize)
    }), _objectSpread(_objectSpread({}, segment), {}, {
      title: '',
      items: segment.items.slice(chunkSize)
    })];
  });
};
export var SegmentsMenuContent = function SegmentsMenuContent(_ref4) {
  var segments = _ref4.segments,
    maxColumnLength = _ref4.maxColumnLength;
  var chunked = maxColumnLength ? chunkSegments(segments, maxColumnLength) : segments;
  return /*#__PURE__*/React.createElement("div", {
    className: "segments-menu"
  }, chunked.map(function (segment, index) {
    return /*#__PURE__*/React.createElement(SegmentsMenuColumn, {
      key: index,
      segment: segment
    });
  }));
};